import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Navigate, Link } from 'react-router-dom'; 

// (임시 CSS)
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontFamily: 'Arial, sans-serif'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    width: '300px' // 너비 추가
  },
  input: {
    marginBottom: '10px',
    padding: '8px',
    fontSize: '16px'
  },
  button: {
    padding: '10px',
    fontSize: '16px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    cursor: 'pointer'
  },
  error: {
    color: 'red',
    marginTop: '10px',
    textAlign: 'center' // 가운데 정렬
  },
  linkContainer: { // 링크 스타일
    marginTop: '15px',
    textAlign: 'center'
  }
};


const LoginPage = () => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // 이미 로그인했다면 메인 페이지로 이동
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const result = await login(userId, password);

    if (result.success) {
      navigate('/', { replace: true });
    } else {
      setError(result.message || '아이디 또는 비밀번호가 올바르지 않습니다.');
    }
  };

  return (
    <div style={styles.container}>
      <h2>노인 일자리 참여자 관리 시스템</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="아이디"
          style={styles.input}
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <input
          type="password"
          placeholder="비밀번호"
          style={styles.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" style={styles.button}>로그인</button>
        {error && <div style={styles.error}>{error}</div>}
      </form>
      
      {/* [추가] 회원가입 링크 */}
      <div style={styles.linkContainer}>
        <Link to="/register">회원가입</Link>
      </div>
    </div>
  );
};

export default LoginPage;